import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { faTimes } from '@/lib/fontAwesomePro/light'
import { cn } from '@/lib/utils'

type Props = Omit<React.ComponentProps<typeof FontAwesomeIcon>, 'icon'> & {
  icon?: IconProp
}

const MobileMenuCloseButton: React.FC<Props> = ({
  className,
  icon,
  style,
  ...props
}) => {
  return (
    <FontAwesomeIcon
      icon={icon || faTimes}
      className={cn(
        `hover-dim absolute top-0 right-0 cursor-pointer bg-transparent
        md:hidden!`,
        className,
      )}
      style={{ fontSize: '26px', padding: '16px 20px 10px', ...style }}
      {...props}
    />
  )
}

export default MobileMenuCloseButton
